import React from "react";
import { Box } from "@mui/material";
import PrecisionManufacturingOutlinedIcon from "@mui/icons-material/PrecisionManufacturingOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import FactoryOutlinedIcon from "@mui/icons-material/FactoryOutlined";
import EngineeringOutlinedIcon from "@mui/icons-material/EngineeringOutlined";
import HandymanOutlinedIcon from "@mui/icons-material/HandymanOutlined";
import HardwareOutlinedIcon from "@mui/icons-material/HardwareOutlined";

const icons = [
  PrecisionManufacturingOutlinedIcon,
  BuildOutlinedIcon,
  SettingsOutlinedIcon,
  ConstructionOutlinedIcon,
  FactoryOutlinedIcon,
  EngineeringOutlinedIcon,
  HandymanOutlinedIcon,
  HardwareOutlinedIcon,
];

const gradients = [
  "linear-gradient(135deg, #3498DB 0%, #5DADE2 100%)",  // Blue
  "linear-gradient(135deg, #27AE60 0%, #52D689 100%)",  // Green
  "linear-gradient(135deg, #8E44AD 0%, #BB6BD9 100%)",  // Purple
  "linear-gradient(135deg, #E67E22 0%, #F5A623 100%)",  // Orange
  "linear-gradient(135deg, #2C3E50 0%, #4A6274 100%)",  // Dark
  "linear-gradient(135deg, #16A085 0%, #48C9B0 100%)",  // Teal
];

const hashString = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

interface DefaultCompanyLogoProps {
  seed: string;  // company ID or name
  size: number;
}

const DefaultCompanyLogo = ({ seed, size }: DefaultCompanyLogoProps) => {
  const hash = hashString(seed || "default");
  const Icon = icons[hash % icons.length];
  const bg = gradients[hash % gradients.length];
  const iconSize = Math.round(size * 0.45);

  return (
    <Box sx={{
      width: size, height: size, borderRadius: "8px",
      background: bg, display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <Icon sx={{ fontSize: iconSize, color: "rgba(255,255,255,0.85)" }} />
    </Box>
  );
};

export default DefaultCompanyLogo;
